import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { STORAGE_KEYS } from '@/atoms/storageKeys';
import type { TrainTogetherModeState } from '@/atoms/trainTogetherMode.storage';
import {
  DEFAULT_TRAIN_TOGETHER_MODE_DATA,
  DEFAULT_TRAIN_TOGETHER_MODE_STATE,
  trainTogetherModeStorage,
} from '@/atoms/trainTogetherMode.storage';

export type {
  TrainTogetherModeData,
  TrainTogetherModeState,
} from '@/atoms/trainTogetherMode.storage';

export const trainTogetherModeBaseAtom = atomWithStorage(
  STORAGE_KEYS.TRAIN_TOGETHER_MODE,
  DEFAULT_TRAIN_TOGETHER_MODE_STATE,
  trainTogetherModeStorage,
  { getOnInit: true },
);

const base = trainTogetherModeBaseAtom;

export const trainTogetherModeAtom = atom(
  get => get(base),
  (get, set, patch: Partial<TrainTogetherModeState>) => {
    set(base, { ...get(base), ...patch });
  },
);

type Action =
  | 'enterTrainTogetherMode'
  | 'exitTrainTogetherMode'
  | 'hideProgressModal'
  | 'showTrainTogetherMode'
  | 'hideTrainTogetherMode'
  | 'showProgressModal'
  | 'resetTrainTogetherModeData';

export const trainTogetherModeDispatchAtom = atom(
  get => get(base),
  (get, set, action: Action) => {
    switch (action) {
      case 'showTrainTogetherMode':
        return set(base, { ...get(base), isTrainTogetherModeOpen: true });
      case 'hideTrainTogetherMode':
        return set(base, { ...get(base), isTrainTogetherModeOpen: false });
      case 'showProgressModal':
        return set(base, { ...get(base), showProgressModal: true });
      case 'hideProgressModal':
        return set(base, { ...get(base), showProgressModal: false });
      case 'enterTrainTogetherMode':
        return set(base, { ...get(base), isTrainTogetherMode: true });
      case 'exitTrainTogetherMode':
        return set(base, { ...get(base), isTrainTogetherMode: false });
      case 'resetTrainTogetherModeData':
        return set(base, {
          ...get(base),
          trainTogetherModeData: DEFAULT_TRAIN_TOGETHER_MODE_DATA,
        });
    }
  },
);
